/* Exemple:
import { hello } from './assets/js/hello'

console.log(hello)
*/

/*
  Fonction qui permet de recupérer dynamiquement les js dans les partials
*/
function requireAll (r) { r.keys().forEach(r) }
requireAll(require.context('./partials/', true, /\.js$/))
